import React, { useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import environmentIcon from '../images/environmentIcon.jpg';
import socialIcon from '../images/socialIcon.jpg';
import governanceIcon from '../images/governanceIcon.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import CounterAnimation from '../components/CounterAnimation';
import './Pages.css';

export default function FY22Highlights()
{
	localStorage.setItem('activeLinkIndex', '2');
	const navigate = useNavigate();
	const leftArrowRef = useRef(null);
	const rightArrowRef = useRef(null);

	return (
		<>
		<div className='main-container'>
		<Container>
			<div className='contentArea flex'>
				<Row className='headerRow'>
					<h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>FY 2025 highlights</h1>
				</Row>
				<hr/>
				<Row className='pb-5 gx-5 noScrollRow'>
					<Col>
						<Row className='gx-5'>
							<Col lg={4}>
								<div className='stat'>
									<div className='statFloatLeft'>
										<img alt='An icon of a hand holding a globe with a plant inside.' src={environmentIcon} style={{width: '100%'}} />
									</div>
									<div className='statFloatRight'>
										<span style={{fontSize: '2rem', fontWeight: '600'}}>Environment</span>
									</div>
								</div>
								<br/>
								<Row>
									<Col xs={6} data-aos='fade-right' data-aos-duration='750' data-aos-once='true'>
										<span className="infographicHeading"><CounterAnimation targetNumber={10.5} />%</span>
						        		<br/>
						        		<span className='infographicSubHeading'>decrease in Scope 1 and 2 GHG emissions</span>
						        		<br/>
						        		<br/>
						        								        		<span className="infographicHeading"><CounterAnimation targetNumber={77} />+</span>
						        		<br/>
						        		<span className='infographicSubHeading'>tons of paper recycled</span>
						        		<br/>
						        		<br/>
						        		<span className="infographicHeading"><CounterAnimation targetNumber={49} />%</span>
						        		<br/>
						        		<span className='infographicSubHeading'>ratio of green spend relative to total office supply spend</span>
					        		</Col>
				        </Row>
							</Col>
							<Col lg={4} className='mt-5 mt-lg-0'>
								<div className='stat'>
									<div className='statFloatLeft'>
										<img alt='An icon of 3 people.' src={socialIcon} style={{width: '100%'}} />
									</div>
									<div className='statFloatRight'>
										<span style={{fontSize: '2rem', fontWeight: '600'}}>Social</span>
									</div>
								</div>
								<br/>
									  <span className="infographicHeading" data-aos='fade-left' data-aos-duration='750' data-aos-once='true'><CounterAnimation targetNumber={25} />K</span>
				        		<br/>
				        		<span className='infographicSubHeading' data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>total employees</span>
				        		<br/>
				        		<br/>
				        		 <span className="infographicHeading" data-aos='fade-left' data-aos-duration='750' data-aos-once='true'><CounterAnimation targetNumber={213} />K+</span>
				        		<br/>
				        		<span className='infographicSubHeading' data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>total training hours</span>
							</Col>
							<Col lg={4} className='mt-5 mt-lg-0'>
								<div className='stat'>
									<div className='statFloatLeft'>
										<img alt='An icon of a scale.' src={governanceIcon} style={{width: '100%'}} />
									</div>
									<div className='statFloatRight'>
										<span style={{fontSize: '2rem', fontWeight: '600'}}>Governance</span>
									</div>
								</div>
								<br/>
								<span className="infographicHeading" data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>8&nbsp;<span style={{fontWeight: '600', fontSize: '2rem'}}>out of&nbsp;</span>9</span>
				        		<br/>
				        		<span className='infographicSubHeading' data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>ratio of independent<br/>
board members</span>
				        		<br/>
				        		<br/>
				        		<span className="infographicHeading" data-aos='fade-left' data-aos-duration='750' data-aos-once='true'><CounterAnimation targetNumber={100} />%</span>
				        		<br/>
				        		<span className='infographicSubHeading' data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>board committees are chaired<br/> by independent directors</span>
				        		<br/>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		</Container>
		</div>
		<div className='navigationArrows'>
		<div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
		        onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/president-and-ceo-message');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
              	    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
              	    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[1].classList.add('active');
              document.getElementsByClassName('underline')[1].classList.add('active');
            }}>
			<FontAwesomeIcon icon={faArrowLeft} />
		</div>
		<div ref={rightArrowRef} className='arrowContainer rightArrow'
				onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
		        onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }}  onClick={() => {
              navigate('/fy2025-awards-and-recognition');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[3].classList.add('active');
              document.getElementsByClassName('underline')[3].classList.add('active');
            }}>
			<FontAwesomeIcon icon={faArrowRight} />
		</div>
	</div>
		</>
	);
}